import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ScrollText } from 'lucide-react';
import { Button } from '../components/ui/button';

const SECTIONS = [
  {
    title: 'Éditeur du site',
    body: (
      <>
        <p>
          Le site <strong>terreetmer-locationdelinge.fr</strong> est conçu et édité par la
          {' '}<strong>SAS MA CONCIERGERIE BRETONNE</strong>, société par actions simplifiée
          au capital de 6 000 €.
        </p>
        <ul className="space-y-1.5 mt-3">
          <li><span className="text-[#64748B]">Siège social :</span> 40 Bis Rue de Dinard, 35730 PLEURTUIT</li>
          <li><span className="text-[#64748B]">RCS :</span> Saint-Malo</li>
          <li><span className="text-[#64748B]">SIRET :</span> 883 753 469 000 21</li>
          <li><span className="text-[#64748B]">N° TVA intracommunautaire :</span> FR62 883 753 469</li>
          <li><span className="text-[#64748B]">Directeur de la publication :</span> SAS MA CONCIERGERIE BRETONNE</li>
          <li><span className="text-[#64748B]">Contact :</span> <a href="mailto:contact@terreetmer-locationdelinge.fr" className="text-[#E8945A] hover:underline">contact@terreetmer-locationdelinge.fr</a></li>
          <li><span className="text-[#64748B]">Téléphone :</span> 02 55 99 66 25</li>
        </ul>
      </>
    ),
  },
  {
    title: 'Hébergement',
    body: (
      <>
        <p>
          Le site <strong>terreetmer-locationdelinge.fr</strong> est hébergé par
          {' '}<strong>Amazon Web Services EMEA SARL (AWS)</strong>, société à responsabilité
          limitée immatriculée au RCS de Luxembourg sous le numéro B186284.
        </p>
        <ul className="space-y-1.5 mt-3 text-sm text-[#64748B]">
          <li><span>Siège social :</span> 38 avenue John F. Kennedy, L-1855 Luxembourg</li>
          <li><span>Site :</span> <a href="https://aws.amazon.com" target="_blank" rel="noopener noreferrer" className="text-[#E8945A] hover:underline">aws.amazon.com</a></li>
        </ul>
        <p className="mt-3 text-sm text-[#64748B]">
          Le nom de domaine est administré via{' '}
          <strong>1&amp;1 IONOS SARL</strong> au capital de 100 000 € — Siège social :
          7 place de la Gare, BP 70109, 57201 Sarreguemines Cedex — RCS Sarreguemines B 431 303 775 —
          SIRET 431 303 775 000 16.
        </p>
      </>
    ),
  },
  {
    title: 'Activité du site',
    body: (
      <p>
        Le site <strong>terreetmer-locationdelinge.fr</strong> est une plateforme de e-commerce
        permettant la <strong>location courte durée de linge de maison</strong> (kits de draps,
        serviettes, tapis de bain, torchons) pour particuliers, propriétaires de meublés de tourisme,
        agences immobilières et conciergeries. Les commandes sont fermes et définitives à compter
        du paiement (voir CGV — Article 22).
      </p>
    ),
  },
  {
    title: 'Propriété intellectuelle',
    body: (
      <>
        <p>
          <strong>TERRE ET MER LOCATION DE LINGE</strong> est une dénomination commerciale exploitée
          par la SAS MA CONCIERGERIE BRETONNE.
        </p>
        <p className="mt-3">
          Copyright © {new Date().getFullYear()} — La reproduction, même partielle, de tout texte,
          image ou photo présents sur ce site est strictement interdite sans accord préalable et écrit
          de la SAS MA CONCIERGERIE BRETONNE.
        </p>
        <p className="mt-3 text-sm text-[#64748B]">
          Les logos, marques et marques déposées de tiers cités sur ce site demeurent la propriété
          de leurs détenteurs respectifs et sont mentionnés à titre purement informatif.
        </p>
      </>
    ),
  },
  {
    title: 'Données personnelles & RGPD',
    body: (
      <>
        <p>
          Conformément au <strong>Règlement Général sur la Protection des Données (RGPD —
          Règlement UE 2016/679)</strong> et à la <strong>Loi Informatique et Libertés modifiée</strong>,
          les données personnelles collectées via ce site (création de compte client, formulaire
          de commande) font l'objet d'un traitement automatisé par la SAS MA CONCIERGERIE BRETONNE.
        </p>
        <div className="mt-4 space-y-3">
          <div>
            <p className="font-semibold text-[#2D3E50]">Données collectées</p>
            <p className="text-sm">
              Nom, prénom, email, téléphone, adresses de livraison et de facturation,
              dates de séjour, historique de commandes et de paiements (les données bancaires
              sont traitées exclusivement par notre prestataire de paiement Mollie B.V., sans transit
              ni stockage par notre site).
            </p>
          </div>
          <div>
            <p className="font-semibold text-[#2D3E50]">Finalités du traitement</p>
            <p className="text-sm">
              Exécution de votre commande de location de linge (préparation, livraison,
              facturation, récupération du linge, gestion de la relation client),
              respect de nos obligations légales et comptables, et — uniquement avec votre
              consentement — envoi de communications commerciales relatives à nos services.
            </p>
          </div>
          <div>
            <p className="font-semibold text-[#2D3E50]">Durée de conservation</p>
            <p className="text-sm">
              Les données de commande sont conservées <strong>10 ans</strong> à compter de
              la dernière commande (obligation comptable légale — article L.123-22 du Code
              de commerce). Les données prospect sans commande : <strong>3 ans</strong> à
              compter du dernier contact.
            </p>
          </div>
          <div>
            <p className="font-semibold text-[#2D3E50]">Vos droits</p>
            <p className="text-sm">
              Conformément aux articles 15 à 22 du RGPD, vous disposez d'un droit d'accès,
              de rectification, d'effacement, de portabilité, de limitation et d'opposition
              concernant vos données. Pour exercer ces droits, adressez votre demande par
              email à <a href="mailto:contact@terreetmer-locationdelinge.fr" className="text-[#E8945A] hover:underline">contact@terreetmer-locationdelinge.fr</a>{' '}
              en justifiant de votre identité.
            </p>
          </div>
        </div>
        <p className="mt-4 text-sm">
          Vous pouvez également introduire une réclamation auprès de la <strong>Commission
          Nationale de l'Informatique et des Libertés (CNIL)</strong>, 3 place de Fontenoy,
          TSA 80715, 75334 Paris Cedex 07 — <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#E8945A] hover:underline">www.cnil.fr</a>.
        </p>
        <p className="mt-3 text-sm">
          Vos données ne sont jamais cédées, vendues ou louées à des tiers sans votre consentement explicite.
        </p>
      </>
    ),
  },
  {
    title: 'Démarchage téléphonique (BLOCTEL)',
    body: (
      <p>
        Conformément à la loi du 17 mars 2014 relative à la consommation, vous pouvez à tout
        moment vous inscrire gratuitement sur la liste d'opposition au démarchage téléphonique
        BLOCTEL — <a href="https://www.bloctel.gouv.fr" target="_blank" rel="noopener noreferrer" className="text-[#E8945A] hover:underline">www.bloctel.gouv.fr</a>.
      </p>
    ),
  },
  {
    title: 'Cookies & traceurs',
    body: (
      <>
        <p>
          Ce site utilise uniquement des <strong>cookies techniques nécessaires à son bon
          fonctionnement</strong> (session client, panier, préférences d'affichage). Aucun
          cookie de profilage publicitaire ou de mesure d'audience tierce n'est déposé sans
          votre consentement explicite.
        </p>
        <p className="mt-3 text-sm">
          Vous pouvez à tout moment configurer votre navigateur pour refuser les cookies ou
          en supprimer l'enregistrement. Le refus des cookies techniques peut altérer le bon
          fonctionnement de certaines pages (impossibilité de finaliser une commande, par exemple).
        </p>
      </>
    ),
  },
  {
    title: 'Liens hypertextes',
    body: (
      <>
        <p>
          Le site terreetmer-locationdelinge.fr peut contenir des liens vers des sites tiers
          (prestataire de paiement, partenaires conciergeries, autorités administratives).
          La SAS MA CONCIERGERIE BRETONNE n'exerce aucun contrôle sur le contenu de ces sites
          externes et ne saurait être tenue responsable de leur contenu, de leurs pratiques ou
          des dommages éventuels résultant de leur consultation.
        </p>
        <p className="mt-3 text-sm">
          La création de liens vers le site terreetmer-locationdelinge.fr est autorisée à
          condition qu'ils ne portent pas atteinte aux intérêts de la SAS MA CONCIERGERIE BRETONNE
          et qu'ils mentionnent clairement la source.
        </p>
      </>
    ),
  },
  {
    title: 'Limitation de responsabilité',
    body: (
      <p>
        Les informations diffusées sur ce site sont fournies à titre indicatif et peuvent être
        modifiées à tout moment sans préavis. La SAS MA CONCIERGERIE BRETONNE met tout en œuvre
        pour assurer l'exactitude des informations diffusées (descriptifs des kits, tarifs,
        zones de livraison) mais ne saurait être tenue responsable des erreurs, omissions ou
        résultats qui pourraient découler de leur utilisation. En cas de divergence entre les
        descriptifs et les CGV, ce sont les CGV qui prévalent.
      </p>
    ),
  },
  {
    title: 'Litiges & médiation de la consommation',
    body: (
      <>
        <p>
          En cas de litige entre le Client et l'entreprise, ceux-ci s'efforceront de le résoudre
          à l'amiable (le Client adressera une réclamation écrite par email à
          {' '}<a href="mailto:contact@terreetmer-locationdelinge.fr" className="text-[#E8945A] hover:underline">contact@terreetmer-locationdelinge.fr</a>).
        </p>
        <p className="mt-3">
          À défaut d'accord amiable ou en l'absence de réponse du professionnel dans un délai
          raisonnable d'<strong>un (1) mois</strong>, le Client consommateur au sens de
          l'article L.133-4 du code de la consommation a la possibilité de saisir gratuitement
          le médiateur compétent inscrit sur la liste des médiateurs établie par la Commission
          d'évaluation et de contrôle de la médiation de la consommation, à savoir :
        </p>
        <div className="mt-4 p-4 bg-[#FAFAFA] border-l-2 border-[#E8945A] rounded">
          <p className="font-semibold text-[#2D3E50]">La Société Médiation Professionnelle</p>
          <p className="text-sm mt-1">24 rue Albert de Mun — 33000 Bordeaux</p>
          <p className="text-sm mt-1">
            <a href="https://www.mediateur-consommation-smp.fr" target="_blank" rel="noopener noreferrer" className="text-[#E8945A] hover:underline">
              www.mediateur-consommation-smp.fr
            </a>
          </p>
        </div>
        <p className="mt-4 text-sm">
          Conformément à l'article 14 du Règlement (UE) n° 524/2013, la Commission Européenne a
          mis en place une plateforme de Règlement en Ligne des Litiges (RLL) accessible à
          l'adresse : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#E8945A] hover:underline">ec.europa.eu/consumers/odr</a>.
        </p>
      </>
    ),
  },
  {
    title: 'Droit applicable & juridiction compétente',
    body: (
      <p>
        Les présentes mentions légales et l'utilisation du site sont régies par le{' '}
        <strong>droit français</strong>. En cas de litige et après échec de toute tentative de
        résolution amiable, les <strong>tribunaux français</strong> seront seuls compétents pour
        en connaître.
      </p>
    ),
  },
];

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen pt-20 md:pt-24 pb-16 bg-[#F1F5F9]" data-testid="mentions-legales-page">
      {/* Hero */}
      <section className="bg-gradient-to-br from-[#2D3E50] to-[#3D5266] text-white py-14 md:py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-5"
            data-testid="mentions-back-home"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour à l'accueil
          </Link>
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#E8945A] font-medium mb-3">
            <ScrollText className="h-4 w-4" />
            Informations légales
          </span>
          <h1 className="font-['Playfair_Display'] text-3xl sm:text-4xl md:text-5xl tracking-tight font-medium leading-tight">
            Mentions légales
          </h1>
          <p className="mt-4 text-white/70 text-sm md:text-base max-w-2xl leading-relaxed">
            Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575
            du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN).
          </p>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-10 md:py-14">
        <div className="bg-white rounded-2xl border border-[#E2E8F0] divide-y divide-[#E2E8F0]">
          {SECTIONS.map((section, idx) => (
            <article
              key={idx}
              className="p-6 md:p-8"
              data-testid={`mentions-section-${idx}`}
            >
              <div className="flex items-start gap-4">
                <span className="font-['Playfair_Display'] text-[#E8945A] text-2xl font-medium leading-none mt-0.5 flex-shrink-0 min-w-[1.5rem]">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <div className="flex-1 min-w-0">
                  <h2 className="font-['Playfair_Display'] text-xl md:text-2xl font-medium text-[#2D3E50] mb-3">
                    {section.title}
                  </h2>
                  <div className="text-[#475569] leading-relaxed space-y-2 text-sm md:text-[15px]">
                    {section.body}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-xs text-[#64748B] mt-8">
          Dernière mise à jour : mai 2026.
        </p>

        <div className="mt-10 text-center">
          <Link to="/cgv">
            <Button variant="outline" className="gap-2" data-testid="mentions-to-cgv">
              Consulter les CGV
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
